/* eslint-disable */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setBlogsList } from "../../../../../redux/actions/action";
import { useWebSocket } from "../../../../api/websocket/WebSocketContext";
import { ADD_BLOG_URL } from "../../../../constant/url";
import {
  deletePageContaint,
  editStatusContaint,
  initialPage,
} from "../../../../utils/staticdata";
import { IPages, IToggleWarnModalTypes } from "../../../../utils/types";
import WarnPopup from "../../../components/popup/WarnPopup";
import TableLayout from "../../../components/TableLayout";
import List from "./list";

const Blogs = () => {
  const { send, receivedMessage, isConnect } = useWebSocket();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showWarn, setShowWarn] = useState<IToggleWarnModalTypes>("hide");
  const [id, setid] = useState("");
  const [EditStatus, setEditStatus] = useState<IPages>();
  const toggleWarn = (e: any, item: any, type: string) => {

    if (type === "delete") {
      setid(item);
      setShowWarn("delete");
    }
    if (type === "hide") {
      setShowWarn("hide");
    }

    if (type === "edit") {
      const Data: any = {
        // page_id: item?.id,
        // is_active: e.target.checked ? "1" : "0",
        // title: item?.title,
        // description: item?.description,
        // type: item?.type,
      };
      setEditStatus(Data);

      setShowWarn("edit");
    }
  };

  const deletePage = () => {
    const data =  {
        "transmit": "single",
        "url": "blog_delete",
        "request": {
          "blog_id": id
        }
    }
    
    send(data);
  };

  const updateStatus = () => {
    // const data = { ...edit_page, request: EditStatus };
    // send(data);
  };
  const blog_request = {
    "transmit": "single",
    "url": "blog_listing",
    "request": {
      "filter": "all",
      "limit": 10,
      "page": 1,
      "search": null
    }
}

  useEffect(() => {
    if (isConnect) {
      if (receivedMessage) {
        if (receivedMessage?.url === "blog_listing") {
          if (receivedMessage?.response?.status === 200)
            dispatch(setBlogsList(receivedMessage?.response?.data));
          if (receivedMessage?.response?.status === 400)
            dispatch(setBlogsList(initialPage));
        }
        if (receivedMessage?.url === "blog_delete") {
          if (receivedMessage?.response?.status === 200) {
            toast.success(receivedMessage?.response?.msg);
            send(blog_request)
          }
          setShowWarn("hide");
        }
        if (receivedMessage?.url === "blog_update") {
          if (receivedMessage?.response?.status === 200) {
          }
          setShowWarn("hide");
        }
      }
    }
  }, [receivedMessage]);



  useEffect(() => {
    if (isConnect) {
      const message = blog_request;
      send(message);
    }
  }, [isConnect]);

//   useEffect(() => {
//     return () => {
//       page_lists.request = {
//         filter: "all",
//         limit: 10,
//         page: 1,
//         search: "",
//       };
//     };
//   }, []);

  return (
<>
<TableLayout
      isAdd
      isFilter ={false}
      title={"Blogs"}
      payload={blog_request}
      handleOpen={() => navigate(ADD_BLOG_URL)}
    >
      <List toggleWarn={toggleWarn} />
      <WarnPopup
        toggleModal={toggleWarn}
        onSubmit={showWarn !== "edit" ? deletePage : updateStatus}
        containt={showWarn !== "edit" ? deletePageContaint : editStatusContaint}
        showModal={showWarn}
      />
    </TableLayout>
</>
  );
};

export default Blogs;
